import { Loader2 } from "lucide-react";

/** Greys a list that is already on screen while a replacement page loads. */
export function ListLoadingOverlay({ show }: { show: boolean }) {
  if (!show) return null;
  return (
    <output
      className="absolute inset-0 z-40 flex items-center justify-center gap-2 bg-background/70"
      aria-live="polite"
    >
      <Loader2 className="h-5 w-5 animate-spin" aria-hidden />
      <span className="text-sm font-medium">Loading list…</span>
    </output>
  );
}
